// extracted by css-extract-rspack-plugin
module.exports =  {"newPrice":"BulkApplyDiscountDialog__newPrice___OyTGb","negativePrice":"BulkApplyDiscountDialog__negativePrice___UR78U"};